module.exports = __webpack_public_path__ + "img/weChat_client.6b16c8aa.png";